module.exports = __webpack_public_path__ + "static/assets/f79950112152d30a89c54961386d3333.png";